import type { ReportResources } from './en-US.js';

export const zhHant: ReportResources = {
  nav: {
    report: '我的週報',
    history: '歷史',
    team: '團隊',
  },
  report: {
    title: '週報',
    titleOf: '{{name}} 的週報',
    previousWeek: '上一週',
    nextWeek: '下一週',
    thisWeek: '本週',
    pickWeek: '週',
    planThisWeek: '本週計畫',
    days: '日報',
    planNextWeek: '下週計畫',
    editableUntil: '可編輯至 {{deadline}}',
    lockedSince: '已於 {{deadline}} 截止',
    confirmedBy: '{{name}} 已確認（{{time}}）',
    notWritten: '尚未填寫。',
    inherited: '已沿用上週的「下週計畫」。請編輯後儲存。',
    save: '儲存',
    saved: '已儲存。',
    unsaved: '有未儲存的變更',
    draftFound: '此裝置上保留了 {{time}} 的未儲存變更。',
    restoreDraft: '還原',
    discardDraft: '捨棄',
    conflict: '此週報已在其他地方被修改。請重新載入；您輸入的內容將保留為草稿。',
    reload: '重新載入',
    leaveTitle: '不儲存就離開？',
    leave: '離開',
    stay: '留下',
    workTimesUnavailable: '暫時無法取得工作時間。',
    modified: '已更正',
    history: '歷史',
  },
  editor: {
    bold: '粗體',
    italic: '斜體',
    underline: '底線',
    strike: '刪除線',
    bulletList: '項目符號清單',
    orderedList: '編號清單',
    link: '連結',
    linkAddress: '連結位址（https://… 或 mailto:…）',
    invalidLink: '請輸入以 https://、http:// 或 mailto: 開頭的位址。',
    removeLink: '移除連結',
    clearFormatting: '清除格式',
    undo: '復原',
    redo: '重做',
  },
  revisions: {
    title: '變更歷史',
    empty: '尚無變更。',
    inherited: '沿用',
    before: '變更前',
    after: '變更後',
    planThisWeek: '本週計畫',
    planNextWeek: '下週計畫',
    day: '日報 {{date}}',
  },
  history: {
    title: '歷史',
    week: '週',
    status: '狀態',
    deadline: '截止時間',
    confirmedAt: '確認時間',
    empty: '尚無週報。',
  },
  team: {
    group: '群組',
    allGroups: '所有群組',
    title: '團隊週報',
    member: '成員',
    weeks: '週數',
    unconfirmedOnly: '僅未確認',
    missing: '未填寫',
    locked: '已過截止時間',
    empty: '沒有成員。',
  },
  audit: {
    title: '稽核記錄',
    time: '時間',
    actor: '執行者',
    action: '操作',
    target: '對象',
    system: '系統',
    actions: {
      ReportConfirmed: '確認週報',
      ReportUnconfirmed: '取消確認',
      LocalAdminGranted: '新增管理員',
      LocalAdminRevoked: '移除管理員',
    },
  },
};
